<script> 
    import {mode} from './stores.js';
    let src = '/img/4.png';
</script>

<body>
<center>
<h1>Contact Us</h1>
</center>

    <div class="subbox"><h2>Chidsanuphong Pengchai</h2> <br>chidsanuphong3@gmail.com</div>
    <div class="subbox"> <h2>Nichapa pornpattanadul</h2><br>nichapa.por@dome.tu.ac.th</div>
    <div class="subbox"> <h2>Peerapat Supasri</h2><br> AsuraA93@gmail.com</div>
    <div class="subbox"> <h2>Sathit Juntanasatan</h2><br>sathit.jun03@gmail.com</div>
    <div class="subbox"> <h2>Tawan Phonsapsin</h2><br>txwxnpp@hotmail.com</div>
    <div><img {src}  class = "photo" alt=""></div>
</body>

<style>
    
    body{font-family: 'K2D', sans-serif;}

    h1{
    color: rgba(101, 99, 186, 1);
    font-family: 'K2D', sans-serif;
    }

    h2{
    color: rgba(101, 99, 186, 1);
    font-size: 22px;
    margin-bottom: -20px;
    }

    .subbox{
		width: 380px;
		height: 110px;
		background-color: white;
		border-radius: 20px;
      	color: rgba(0, 148, 255, 1);
		font-size: 20px;
		margin-left: 60%;
        margin-bottom: 20px;
		padding: 20px;
        text-align: center;
    }

    .photo{ 
        position: relative;
        top: -500px;
        left: 160px;
        background-size: cover;
        height: 400px;
        display: inline-block;
}


</style>
